export const sortByPrio = <T extends { prio?: number }>(parameters: T[]): T[] => {
  const sortedParameters = [...parameters];
  sortedParameters.sort((paramA, paramB) => {
    if (paramA.prio && !paramB.prio) {
      return -1;
    }

    if (!paramA.prio && paramB.prio) {
      return 1;
    }

    if (paramA.prio && paramB.prio) {
      if (+paramA.prio < +paramB.prio) {
        return -1;
      }
      if (+paramA.prio > +paramB.prio) {
        return 1;
      }
    }
    return 0;
  });
  return sortedParameters;
};
